import React from 'react';
import styles from './NotifyToField.module.scss';
import { fieldNames } from '../../../common/config';
import { Form, Icon, Tooltip } from 'antd';
import { useShutdownNotifications } from '../../../../../shared/api/queries/shutdownNotifications';
import { getOptionsBySelect } from '../../lib/getOptionsBySelect';
import DropdownSelect from '../../../../../../../components/dropdownSelect';

const notifyToFieldName = fieldNames.notifyTo;
const cityFieldName = fieldNames.city;
const FormItem = Form.Item;

const tooltips = new Map([
  // городские службы
  [
    1,
    'отправится уведомление на электронную почту с приложением соответствующего отчета, настроенного в системе',
  ],
  // Собственники
  [
    2,
    'отправится push-уведомление в мобильное приложение собственников, при звонке в аварийно-диспетчерскую службу активируется автоинформатор с сообщением об отключении',
  ],
  // Сотрудники
  [3, 'отправится push-уведомление в мобильное приложение сотрудников'],
]);

const TooltipTitle = ({ items }) => {
  return (
    <ul className={styles.tooltipTitleContainer}>
      {items.map((item) =>
        tooltips.has(item.id) ? (
          <li key={item.id}>
            <b>{item.name}</b> - {tooltips.get(item.id)}
          </li>
        ) : null
      )}
    </ul>
  );
};

const Label = ({ items }) => {
  return (
    <span>
      Отправить уведомление&nbsp;
      {Boolean(items?.length) && (
        <Tooltip title={<TooltipTitle items={items} />}>
          <Icon
            type="info-circle"
            style={{ fontSize: '16px' }}
          />
        </Tooltip>
      )}
    </span>
  );
};

const NotifyToField = ({ form }) => {
  const cityId = form.getFieldValue(cityFieldName);

  const { data = [], isFetching } = useShutdownNotifications(cityId, {
    staleTime: Infinity,
    enabled: Boolean(cityId),
  });

  const options = getOptionsBySelect(data);

  const isDisabled = isFetching || !cityId;

  return (
    <FormItem
      label={<Label items={data} />}
      style={{ margin: 0 }}
    >
      {form.getFieldDecorator(notifyToFieldName)(
        <DropdownSelect
          options={options}
          disabled={isDisabled}
          loading={isFetching}
          multiple
        />
      )}
    </FormItem>
  );
};

export default NotifyToField;
